import React from 'react';

import { useAppContext } from '@prisjakt/ui-app-context';

import { H3Text } from '@prisjakt/ui/text/variants';
import ContentCards from '../../../../expert/components/list-of-content-cards';

import { useEffectOnMount } from 'src/hooks/useEffectOnMount';

import {
  trackSearchResultExpertArticleClicked,
  trackSearchResultExpertArticlesListed,
} from '../../../tracking';

import { ExpertItems } from 'src/areas/expert/components/list-of-content-cards/types';
import { TabAnchor } from '../../navigation/types';

import { Section } from '../styles';
import { StyledList } from './styles';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

type Props = {
  active: boolean;
  count: number;
  items: ExpertItems;
  query: string;
  visible: boolean;
  wideContent: boolean;
};

export const TestAndGuideResults = (props: Props) => {
  const { active, count, items, query, visible, wideContent } = props;

  const { t } = useAppContext();

  useEffectOnMount(() => {
    if (items.length) trackSearchResultExpertArticlesListed();
  });

  if (!items.length) return null;

  return (
    <Section id={TabAnchor.TESTS} $visible={visible}>
      <H3Text>{`${t('search', 'tests.title')} (${count})`}</H3Text>

      <StyledList
        $active={active}
        $columns={wideContent ? 5 : 4}
        $count={count}
      >
        <ContentCards
          onClick={onClickData => {
            trackSearchResultExpertArticleClicked(
              onClickData.id,
              onClickData.title,
              onClickData.type,
              onClickData.url,
              query
            );
            trackInternalNavigationClick({
              scope: InternalNavigationScope.ARTICLE_CONTENT_CARD,
              nextPage: onClickData.url,
              index: onClickData.index,
            });
          }}
          items={items}
          imageSize={150}
        />
      </StyledList>
    </Section>
  );
};
